module.exports = __webpack_public_path__ + "assets/img/img-chara-search.ef7592e8.svg";